module.exports = __webpack_public_path__ + "img/核桃仁.20381334.jpg";